import React from 'react';
import { WindowLocation } from '@reach/router';
import uuid from 'uuid-random';
import {
  StyledFooter,
  StyledFooterWrapper,
  StyledLeftSideWrapper,
  StyledFooterLink,
  StyledFooterButton,
  StyledFooterLine,
  StyledUnderline,
} from '../Styled';
import { getPath, getStageColors } from '../../utils';
import { items, copyright, FooterItemType } from '../../constants/footer';
import { EXEMPLARS_NAV_LIST, MAIN_NAV_LIST, LESSONS } from '../../constants';
import { WRITING_PROFORMA } from '../../constants/navigation';
import { useQuery } from '../../hooks/useQuery';
import { ButtonVariant } from 'react-magma-dom';

interface IFooter {
  location: WindowLocation<unknown> | undefined;
  setIsTermsOfUseModalOpened: (isOpened: boolean) => void;
}

export const Footer = (props: IFooter): JSX.Element => {
  const { location, setIsTermsOfUseModalOpened } = props;

  const stage = useQuery('stage')?.toLowerCase();

  const navList = EXEMPLARS_NAV_LIST.concat([...MAIN_NAV_LIST, LESSONS, WRITING_PROFORMA]);
  const path = getPath(location) as string;

  let pathName = '';
  if (stage) {
    pathName = stage;
  } else if (navList.includes(path)) {
    pathName = path;
  } else {
    pathName = location?.pathname.split('/').slice(-1).pop() as string;
    pathName = navList.includes(pathName) ? pathName : '';
  }

  const { main: mainColor } = getStageColors(pathName);

  return (
    <StyledFooter color={mainColor}>
      <StyledFooterWrapper>
        <StyledLeftSideWrapper>
          {items.map((item, index) => {
            const footerItem =
              item.type === FooterItemType.link ? (
                <StyledFooterLink key={item.to} testId="footer-link" isInverse target="_blank" to={item.to}>
                  {item.text}
                </StyledFooterLink>
              ) : (
                <StyledFooterButton
                  onClick={() => {
                    setIsTermsOfUseModalOpened(true);
                  }}
                  key={uuid()}
                  testId="footer-button"
                  variant={ButtonVariant.link}
                >
                  {item.text}
                </StyledFooterButton>
              );

            if (index === 0) {
              return footerItem;
            }

            return (
              <React.Fragment key={uuid()}>
                <StyledFooterLine key={uuid()} />
                {footerItem}
              </React.Fragment>
            );
          })}
        </StyledLeftSideWrapper>
        <StyledFooterLink testId="footer-link" isInverse target="_blank" to={copyright}>
          <span>
            © {new Date().getFullYear()} <StyledUnderline>Cengage Learning</StyledUnderline> Australia Limited
          </span>
        </StyledFooterLink>
      </StyledFooterWrapper>
    </StyledFooter>
  );
};
